import React from 'react';
import AsaActivityList from '../components/AsaActivityList'

const AsaPage = () => {
  return (
    <div>
      {/* <h1>AfterSchool Activities</h1> */}
      <h3>Make payments for Lincoln Fund, ASA, WAISAL, and summer camp</h3>
      <hr></hr>
      <AsaActivityList />
    </div>
  );
};

export default AsaPage;
